import { IBulkOrderTransport } from "@/types/IBulkOrder"
import { ITableColumn } from "@/types/ui"

export const transportColumns: ITableColumn<IBulkOrderTransport>[] = [
    {
        title: "Водитель",
        key: "driverName",
        dataIndex: ["driverName"],
        isVisible: true,
        order: 1
    },
    {
        title: "Транспорт",
        key: "transportName",
        dataIndex: ["transportName"],
        isVisible: true,
        order: 2
    },
    {
        title: "Дата отгрузки",
        key: "date",
        dataIndex: ["date"],
        isVisible: true,
        order: 3,
        render: (_, { date }) => new Date(date).toLocaleDateString("ru-RU")
    }
]